import * as Yup from 'yup';

export const toMail = 'emprunteur.plus@nevidis.fr';
export const copyMail = {
  nevidis: 'service.partenaire@nevidis.fr',
  nortia: 'service.partenaire@nortia-protect.fr',
};

export const linkToForm = {
  nevidis: 'https://3au8jpj3wx7.typeform.com/to/Wnn2ZL9O',
  nortia: 'https://3au8jpj3wx7.typeform.com/to/Q4esu3Xz',
};

export const linkToEspace = 'https://secure.lsa.ad1838.ovh/?rd=https%3A%2F%2Flsa.ad1838.ovh%2F&rm=GET';

export const subjectMail = 'Demande de souscription Emprunteur+ By Nevidis';

const consentLabel =
  "Je certifie avoir recueilli le consentement de mon Client pour la communication et le traitement de ses données personnelles par mes partenaires aux fins d'une prise de contact pour la souscription d'une solution d'assurance Emprunteur + by Nevidis.";

export const consentFields = [
  {
    name: consentLabel,
    code: 'consent_box',
    type: 'boolean',
    required: true,
    validation: Yup.bool()
      .required('Le consentement est obligatoire')
      .oneOf([true], 'Le consentement est obligatoire'),
  },
];

export const customerFields = [
  {
    name: 'Civilité',
    code: 'customer_gender',
    type: 'selection',
    required: true,
    selection: [
      { code: '', name: '' },
      { code: 'M.', name: 'M.' },
      { code: 'Mme', name: 'Mme' },
    ],
    validation: Yup.string().required('Le champ Civilité du client est obligatoire'),
  },
  {
    name: 'Nom',
    code: 'customer_name',
    type: 'string',
    required: true,
    validation: Yup.string().required('Le champ Nom du client est obligatoire'),
  },
  {
    name: 'Prénom',
    code: 'customer_firstname',
    type: 'string',
    required: true,
    validation: Yup.string().required('Le champ Prénom du client est obligatoire'),
  },
  {
    name: 'Téléphone',
    code: 'customer_phone',
    type: 'string',
    required: true,
    validation: Yup.string()
      .matches(/^[+0-9]+$/, 'Veuillez saisir un numéro de téléphone valide')
      .required('Le champ Téléphone du client est obligatoire'),
  },
];

export const brokerFields = [
  {
    name: 'Dénomination sociale',
    code: 'broker_social_denomination',
    type: 'string',
  },
  {
    name: 'Civilité',
    code: 'broker_gender',
    type: 'selection',
    selection: [
      { code: '', name: '' },
      { code: 'M.', name: 'M.' },
      { code: 'Mme', name: 'Mme' },
    ],
  },
  {
    name: 'Nom',
    code: 'broker_name',
    type: 'string',
  },
  {
    name: 'Prénom',
    code: 'broker_firstname',
    type: 'string',
  },
];

export const getBodyMail = values => {
  const body = [
    `Objet : ${subjectMail}`,
    `Client :\nCivilité : ${values.customer_gender}\nNom : ${values.customer_name}\nPrénom : ${values.customer_firstname}\nTéléphone : ${values.customer_phone}`,
    `${consentLabel}`,
    `Conseiller :\nDénomination Sociale : ${values.broker_social_denomination ||
      ''}\nCivilité : ${values.broker_gender || ''}\nNom : ${values.broker_name ||
      ''}\nPrénom : ${values.broker_firstname || ''}`,
  ];

  return body.join('\n\n');
};
